// 用于创建仓库，并导出
import {createStore} from 'redux'
import reducer from './reducer'



const store = createStore(
  reducer,
)

export default store
